import * as React from 'react';
import { TrackingContext } from '../context';
import { InitBITrackerParams, TrackingInfo } from '../types';

export type WithTrackingProps = {
  initBITracker: (params: InitBITrackerParams) => void;
  sendBITrackingEvent: (info: TrackingInfo<unknown>) => void;
};

export default function withTracking<P>(
  WrappedComponent: React.ComponentType<P & WithTrackingProps>
): React.FunctionComponent<P> {
  const ComponentWithTracking: React.FunctionComponent<P> = (props: P) => {
    const { initTracker, sendTrackingEvent } = React.useContext(
      TrackingContext
    );

    return (
      <WrappedComponent
        initBITracker={initTracker}
        sendBITrackingEvent={sendTrackingEvent}
        {...props}
      />
    );
  };

  return ComponentWithTracking;
}
